var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"container py-4",attrs:{"id":"main-content"}},[_c('verify-fs-set')],1)}
var staticRenderFns = []

export { render, staticRenderFns }